import React, { useEffect, useRef, useState } from "react";
import Carousel from 'react-multi-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Cards from 'react-bootstrap/Card';
import CardStandard from "./CardStandard";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";

const mobile = window.matchMedia("screen and (max-width: 767px)").matches;
const tablet = window.matchMedia("screen and (max-width: 1024px) and (min-width: 768px)").matches;

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,

  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1,
  },
};


const ButtonGroup = ({ size, next, previous, goToSlide, ...rest }) => {

  var lenghtSlider = size;
  var { carouselState: { currentSlide } } = rest;
  function nextSlide() {
    next();
    var btnRight = document.getElementById('btnRight');
    btnRight.disabled = true;
    // var spanSlide = document.getElementById('spanSlideOffer');
    // var pagination = parseInt(document.getElementById('spanSlideOffer').textContent);
    // if (pagination < lenghtSlider && pagination >= 1) {
    //     spanSlide.textContent = pagination + 1;
    //     btnRight.disabled = false;
    // }
    // else {
    //     spanSlide.textContent = 1
    //     btnRight.disabled = false;
    // }
  }
  function prevSlide() {
    previous();
    var btnLeft = document.getElementById('btnLeft');
    btnLeft.disabled = true;
    // var spanSlide = document.getElementById('spanSlideOffer');
    // var pagination = parseInt(document.getElementById('spanSlideOffer').textContent);
    // if (pagination <= lenghtSlider && pagination > 1) {
    //     spanSlide.textContent = pagination - 1;
    //     btnLeft.disabled = false;
    // }
    // else {
    //     spanSlide.textContent = lenghtSlider
    //     btnLeft.disabled = false;
    // }
  }
  return (
    <div className="carousel-button-group custom-arrow-offer d-flex align-items-center justify-content-center">
      <button id="btnLeft" className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left" onClick={() => prevSlide()}> </button>
      {/* <span className="spanSlide">
                {
                    <span id="spanSlideOffer">1</span>
                } of {
                    lenghtSlider
                }
            </span> */}
      <button id="btnRight" className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right" onClick={() => nextSlide()} > </button>
    </div>
  );
};

const CarouselOffer = ({ offers }) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleCardClick = (url) => {
    navigate(url);
  }

  useEffect(() => {
  }, [currentIndex]);


  return (
    <section className="d-flex ms-5">
      <div className={`mt-5 container-fluid ${(mobile || tablet) ? "px-4" : "p-xs-0"}`}>
        <div className="row">
          <div className="col-lg-5 col-md-5 col-12 p-0 d-flex align-items-center justify-content-end custom-text-carousel-offer">
            <div className={`background-white w-100 h-50 z-3 card-slider-offers shadow-custom text-left py-5 ${(mobile || tablet) ? " px-4" : " px-5"}`}>
              <h4 className="pb-3 text-uppercase title">{offers[currentIndex]?.title ?? ""}</h4>
              <p dangerouslySetInnerHTML={{ __html: offers[currentIndex]?.description ?? "" }}></p>
            </div>
          </div>
          <div className="col-lg-7 col-md-7 col-12 p-0">
            <Carousel
              swipeable={mobile || tablet}
              arrows={false}
              ssr={false}
              draggable={false}
              slidesToSlide={1}
              showDots={false}
              responsive={responsive}
              centerMode={false}
              infinite={true}
              minimumTouchDrag={5}
              rewindWithAnimation={true}
              autoPlay={false}
              keyBoardControl={false}
              transitionDuration={100}
              customTransition="transform .5s linear"
              containerClass="carousel-card-home-offer"
              itemClass="carousel-card-home-item-offer"
              afterChange={(previousSlide, state) => {
                const totalItems = offers.length;
                const newIndex = (state.currentSlide + 1 + totalItems) % totalItems; 
                setCurrentIndex(newIndex); 
              }}

              customButtonGroup={<ButtonGroup size={offers?.length} />}>
              {offers?.map((item, index) => (
                <div
                  className={`position-relative d-flex`}
                  key={index}>

                  <Cards className="card-offer rounded-0 cursor mb-5" >
                    <NavLink className="link" to={item?.url ?? ""}>
                      <Cards.Img variant="top" src={process.env.REACT_APP_SITE_URL + (item?.image ?? "")} />
                    </NavLink>
                    <Cards.Body onClick={() => handleCardClick(item?.url ?? "")} className="card-standard-body p-0">
                      <Cards.Text>
                        <div className="d-flex justify-content-start pt-2 card-text">
                          <NavLink className="link text-uppercase lineEffectBlack" to={item?.url ?? ""}>
                            {item?.title ?? ""}
                          </NavLink>
                        </div>
                      </Cards.Text>
                    </Cards.Body>
                  </Cards>
                </div>
              ))}
            </Carousel>
          </div>
        </div>

      </div>

    </section>
  );
};

export default CarouselOffer;